// extracted by mini-css-extract-plugin
module.exports = {"wrap":"downloadnav-module--wrap--3Xutb","copy":"downloadnav-module--copy--3qkpH"};